<template>
  <div
    class="tab-pane"
    v-show="active"
    :id="id || title"
    :class="{ active: active }"
    :aria-expanded="active"
  >
    <slot v-if="shouldRender"></slot>
  </div>
</template>
<script>
export default {
  name: "tab-pane",
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    lazy: {
      type: Boolean,
      default: true,
    },
  },
  inject: ["addTab", "removeTab"],
  data() {
    return {
      active: false,
      hasBeenActive: false,
    };
  },
  computed: {
    shouldRender() {
      if (!this.lazy) {
        return true;
      }

      return this.active || this.hasBeenActive;
    },
  },
  mounted() {
    this.addTab(this);
    if (this.active) {
      this.hasBeenActive = true;
    }
  },
  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    this.removeTab(this);
  },
  watch: {
    active(newVal) {
      if (newVal) {
        this.hasBeenActive = true;
      }
    },
  },
};
</script>
<style></style>
